// extracted by mini-css-extract-plugin
export default {"card":"AbouList_card__5Wyl7","icon":"AbouList_icon__Byxl+","title":"AbouList_title__hG1qS","text":"AbouList_text__DBz-n"};